import { render } from "./Shonin.vue?vue&type=template&id=3715f2b9&scoped=true"
import script from "./Shonin.vue?vue&type=script&lang=js"
export * from "./Shonin.vue?vue&type=script&lang=js"

import "./Shonin.vue?vue&type=style&index=0&id=3715f2b9&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3715f2b9"]])

export default __exports__